import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";
import type { ContactsListResponse } from "@/react/components/SettingsApp/Workflows/components/CommunityMemberColumn/types";
import { useWorkflowsApi } from "@circle-react/api";
import { useToast } from "@circle-react-uikit/ToastV2";

export const COMMUNITY_MEMBERS_LIST_REQUEST_KEY = "COMMUNITY_MEMBERS_LIST";

interface UseCommunityMembersListParams {
  enabled?: boolean;
  ids: number[];
  withDeleted?: boolean;
}

/**
 * Get list of community members when given an array of IDs
 */
export const useCommunityMembersList = ({
  ids,
  withDeleted,
  enabled,
}: UseCommunityMembersListParams): UseQueryResult<
  ContactsListResponse,
  Error
> => {
  const toastr = useToast();
  const workflowsApi = useWorkflowsApi();

  const fetchCommunityMembersList = () =>
    workflowsApi.fetchContacts({
      params: { ids, with_deleted: withDeleted },
    });

  return useQuery<ContactsListResponse, Error>(
    [COMMUNITY_MEMBERS_LIST_REQUEST_KEY, ids, withDeleted],
    fetchCommunityMembersList,
    {
      enabled,
      onError: err => {
        toastr.error(err.message);
      },
    },
  );
};
